import tenantData from '@data';
import tenantUtils from '@utils';
import { Typography } from 'antd';
import cx from 'clsx';
import { t } from 'i18next';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Flex, Group, Icon } from '../../../../components/common';
import { CardGradient } from '../../../../components/common/cards/styled';
import { CardMetaStyled } from '../../../../container/pages/user-settings/style';
import {
  completeYourProfileClickEvent,
  whyIsProfileCompletionImportantClickEvent,
} from '../../../../services/analyticsService';
import { TruBrokerBanner } from '../../../../components/tru-broker/styled';
import CompleteProfilePopUp from './complete-profile-pop-up';
import ProfileImportanceModal from './profile-importance';
import { AvatarStyled, ProgressStyled } from './style';
const { Title, Text } = Typography;

const ProfileCompletionAlert = ({ style }) => {
  const { user } = useSelector((state) => state.loginUser);
  const isMobile = useSelector((state) => state.AppConfig.isMobile);
  const rtl = useSelector((state) => state.AppConfig.rtl);
  const profileCompletionModalRef = useRef();
  const completeProfileModalRef = useRef();

  const renderProfileImage = () => {
    const renderImage = () => {
      return (
        <AvatarStyled
          size={44}
          src={user?.profile_image}
          showBadge={true}
          badgeColor={tenantData.getClassificationColor(user?.profile_completion?.classification)}
          badgeCount={user?.profile_completion?.score + '%'}
          badgeShape={'square'}
          badgeOffset={rtl ? [20, 42] : [-20, 40]}
          iconContainerSize={'44px'}
        />
      );
    };
    return (
      <ProgressStyled
        size={50}
        type="circle"
        strokeColor={tenantData.getClassificationColor(user?.profile_completion?.classification)}
        percent={user?.profile_completion?.score}
        format={() => renderImage()}
        style={{ marginBlockEnd: 10, '--remaining-color': '#fff' }}
      />
    );
  };

  return (
    <>
      {user?.profile_completion?.score < 100 && (
        <TruBrokerBanner
          as={CardGradient}
          circleShadow={false}
          style={{ '--gradient-val': '-37.9%', '--gradient-val1': '65.73%', ...style }}
          dir={rtl ? 'rtl' : 'ltr'}
        >
          <Group template={'initial'} className="align-items-start" gap="8px">
            <Flex align="start" justify="space-between" gap={isMobile ? '36px' : '50px'}>
              <div className="color-gray-dark fz-12 mb-16">
                <Title level={isMobile ? 5 : 4} className="base-color fw-700 fz-14">
                  {tenantUtils.getLocalisedString(user?.profile_completion, 'title')}
                </Title>

                <Text type="secondary" className={cx('d-block ', isMobile && 'fz-12')} style={{ maxWidth: '38ch' }}>
                  {tenantUtils.getLocalisedString(user?.profile_completion, 'message')}
                </Text>
              </div>
              <CardMetaStyled
                className="p-0"
                style={{ alignItems: 'center', marginTop: '6px' }}
                avatar={renderProfileImage()}
              />
            </Flex>

            <Flex className={'w-100'} justify={isMobile && 'space-between'}>
              {user?.profile_completion?.score < 100 && (
                <Button
                  size={isMobile && 'small'}
                  type={'primary'}
                  onClick={() => {
                    completeProfileModalRef.current && completeProfileModalRef.current.showCompletionPopUp();
                    completeYourProfileClickEvent(user);
                  }}
                >
                  {t('Complete your Profile')}
                </Button>
              )}

              {user?.profile_completion?.score < 100 && (
                <Button
                  type={'link'}
                  size={'small'}
                  className={cx('py-0', isMobile ? 'px-16' : 'px-20')}
                  style={{ '--ant-control-height-sm': 'auto', fontSize: isMobile && '12px' }}
                  onClick={() => {
                    profileCompletionModalRef.current && profileCompletionModalRef.current.showModal();
                    whyIsProfileCompletionImportantClickEvent(user, false);
                  }}
                >
                  {t('Why is this important?')}
                </Button>
              )}
            </Flex>
          </Group>
          <ProfileImportanceModal ref={profileCompletionModalRef} />
          <CompleteProfilePopUp ref={completeProfileModalRef} />
        </TruBrokerBanner>
      )}
    </>
  );
};
export default ProfileCompletionAlert;
